import { IconName } from 'components/core';
import type { ItemGroup } from 'components/core/MemreContextMenu';
import { useAuthoringContext } from '../AuthoringContext';

export default function useMenuItems(itemType: 'survey' | 'set' | 'assessment' | 'assignment') {
  const { create } = useAuthoringContext();

  const instructItems = {
    name: 'Teach and Instruct',
    items: [
      {
        label: 'Make a Page',
        icon: IconName.document,
        onClick: () => create('instructional_contents', undefined, 'instructional_page'),
      },
      {
        label: 'Upload a PDF',
        icon: IconName.filePdf,
        onClick: () => create('instructional_contents', undefined, 'instructional_document'),
      },
    ],
  };

  const surveyItems = {
    name: 'Build Questions',
    items: [
      {
        label: 'Multiple Choice Question',
        icon: IconName.squareCheck,
        onClick: () => create('survey_question_and_answers', 'multi_correct'),
      },
      {
        label: 'Free Response',
        icon: IconName.edit,
        onClick: () => create('free_response'),
      },
      {
        label: 'Rating',
        icon: IconName.sliders,
        onClick: () => create('ratings'),
      },
    ],
  };

  const learningItems = {
    name: 'Build Questions',
    items: [
      {
        label: 'Question & Answers',
        icon: IconName.circleCheck,
        onClick: () => create('question_and_answers'),
      },

      {
        label: 'Sequences',
        icon: IconName.upDownLeftRight,
        onClick: () => create('sequences'),
      },
      {
        label: 'Diagrams',
        icon: IconName.arrowPointer,
        onClick: () => create('regions'),
      },
      {
        label: 'Flashcards',
        icon: IconName.flashcards,
        onClick: () => create('associations'),
      },
      {
        label: 'Vocabulary',
        icon: IconName.vocabulary,
        onClick: () => create('vocabulary'),
      },
    ],
  };

  const extraItems = itemType
    ? {
        survey: surveyItems,
        assessment: learningItems,
        set: learningItems,
      }[itemType]
    : null;

  const menuItems = itemType ? [instructItems, extraItems] : [instructItems];

  return menuItems as ItemGroup[];
}
